function BaseUrl(){
     return "https://stl-v1.iotajra.com";
    // return "https://edotco.iotajra.com";
       return "http://127.0.0.1:8000";
 }
 export default BaseUrl;